import script from "./Jobs.vue?vue&type=script&setup=true&lang=js"
export * from "./Jobs.vue?vue&type=script&setup=true&lang=js"

import "./Jobs.vue?vue&type=style&index=0&id=2fe33d56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe33d56"]])

export default __exports__